import styled from 'styled-components';

export const SatisfactionSurveyPrint = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
